import { render, staticRenderFns } from "./Hospital.vue?vue&type=template&id=aaa7258a&scoped=true"
import script from "./Hospital.vue?vue&type=script&lang=ts"
export * from "./Hospital.vue?vue&type=script&lang=ts"
import style0 from "./Hospital.vue?vue&type=style&index=0&id=aaa7258a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa7258a",
  null
  
)

export default component.exports